export default __webpack_public_path__ + "static/media/about-us-main.014b7247.png";